/**
 * 【KYMW1600】画像ファイルURL取得要求VO
 *
 */
export class GetImageFileUrlModel {
  public extension: string;		// 1:epsのみ、2:pngのみ、3:両方
  public imageIdList: string;		// 画像IDリスト（、区切り）
}
